import { FinanceSequencyTypes } from '../../confirmFinances/confirmFinances.constants';

export const DirectDebitFormFields = [{
  name: 'creditorId',
  type: 'suggest',
  suggest: 'creditorIdSuggest',
  required: true,
  options: {
    validate: 'cid'
  }
}, {
  name: 'name',
  type: 'suggest',
  suggest: 'paymentPartnerSuggest',
  required: true
}, {
  name: 'purpose',
  type: 'text',
}, {
  name: 'mref',
  type: 'text',
  required: true
}, {
  name: 'sequenceType',
  type: 'select',
  typeOptions: {
    modelKey: 'key',
    selectables: FinanceSequencyTypes.map(type => {
      // Disable OOFF option
      if (type.key === 'OOFF') type.disabled = true;
      return type;
    }),
    defaultValue: 'RCUR'
  },
  required: true
}];

export const SuggestSettings = {
  editable: true,
  delay: 200,
  messages: {
    required: 'app.confirmFinaces.required'
  }
};

export const AutofillableCreditors = [
  // AMAZON
  'DE94ZZZ00000561653',
  'DE78ZZZ00000561650',
  'DE51ZZZ00000561651',
  'DE96ZZZ00000594888',
  'DE24ZZZ00000561652',
  // PAYPAL
  'LU96ZZZ0000000000000000058',
  // EBAY
  'GB22SARSDDCHAS00000035351901',
  'GB86CHAS60924235351901',
  // NETFLIX
  'GB96NFXSDDCHAS00000041302392'
];
